module.exports = __webpack_public_path__ + "static/media/061-nun.3dfc18b8.svg";